import type { SVGProps } from 'react';

const SvgArchiveArchived = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M16 3H8C6.35 3 5 4.35 5 6v12c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3M8 5h8c.55 0 1 .45 1 1v5H7V6c0-.55.45-1 1-1m8 14H8c-.55 0-1-.45-1-1v-5h10v5c0 .55-.45 1-1 1"
    />
    <path
      fill="currentcolor"
      d="M14 15h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1m-4-6h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1"
    />
  </svg>
);
export default SvgArchiveArchived;
